var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.03125C7.38384 2.03125 8.24782 2.29334 8.98271 2.78437C9.71759 3.2754 10.2904 3.97333 10.6286 4.78988C10.9668 5.60644 11.0553 6.50496 10.8829 7.37181C10.7105 8.23866 10.2849 9.03492 9.65988 9.65988C9.03492 10.2849 8.23866 10.7105 7.37181 10.8829C6.50496 11.0553 5.60644 10.9668 4.78988 10.6286C3.97333 10.2904 3.2754 9.71759 2.78437 8.98271C2.29334 8.24782 2.03125 7.38384 2.03125 6.5",
    stroke: "#767676",
    strokeWidth: 1.05625,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.03125V6.5H2.03125C2.03125 5.31481 2.50206 4.17817 3.34012 3.34012C4.17817 2.50206 5.31481 2.03125 6.5 2.03125Z",
    stroke: "#767676",
    strokeWidth: 1.05625,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceIcon);
export default __webpack_public_path__ + "static/media/ChoiceIcon.257991d2c5427dc4e0a8ab8741892757.svg";
export { ForwardRef as ReactComponent };